import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { GetCatchUpCarouselUseCase } from './GetCatchUpCarouselUseCase';

export const initializeCmsCarouselUseCases = (container: Container) => {
    container.register(DI.USECASES.IGetCatchUpCarouselUseCase, {
        useClass: GetCatchUpCarouselUseCase,
    });
};
